import React from 'react';
import { VirtualItem, Virtualizer } from '@tanstack/react-virtual';
import { DayOverviewType, OverviewItem } from '../../types';

export enum LoaderElementKeysEnum {
  PREV_LOADER = 'PREV_LOADER',
  NEXT_LOADER = 'NEXT_LOADER',
}

export interface IWeek {
  weekKey: string;
  dateKeys: string[];
  unixDates: number[];
  startDate: number;
  endDate: number;
}

export interface ICalendarWeeksState {
  weeks: IWeek[];
  addedWeekKeysMap: Record<string, true>;
}

export type DayContentSlot = React.ComponentType<{
  dateKey: string;
  date: number;
}>;

export type CalendarOverviewGridProps = {
  initialDate: number;
  timezone: string;
  onLoadData: (weeks: IWeek[]) => Promise<void>;
  DayContentSlot: DayContentSlot;
};

export type CalendarGridProps = {
  containerRef: React.RefObject<HTMLDivElement>,
  virtualizer: Virtualizer<HTMLDivElement, Element>,
  virtualItems: VirtualItem[],
  calendarWeeks: ICalendarWeeksState,
  timezone: string,
  DayContentSlot: DayContentSlot,
};

export type WeekRowContentProps = {
  week: IWeek;
  DayContentSlot: DayContentSlot;
};

export type CalendarDayProps = {
  date: number;
  data: DayOverviewType;
  currentDate: number;
  timezone: string;
};

export type CalendarDayOverviewProps = {
  items: OverviewItem[];
  limit?: number;
};

export type WeekDaysRowProps = {
  timezone: string;
};

export type LoaderRowProps = {
  offsetTop?: number;
};
